import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  BootstrapVue,
  BootstrapVueIcons
} from "bootstrap-vue";
import routes from "./router/router";
import Axios from "axios";
import store from "./store.js";
import vueSmoothScroll from "vue2-smooth-scroll";
import { ENGLISH_TRANSLATIONS } from './translations/en';
import { SWEDISH_TRANSLATIONS } from './translations/se';
import VueI18n from 'vue-i18n';

Vue.prototype.$http = Axios;
const token = localStorage.getItem("token");
if (token) {
  //Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
  Axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${store.state.token}`;
}

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(vueSmoothScroll);

const TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  se: SWEDISH_TRANSLATIONS
}

const i18n = new VueI18n({
  locale: 'se',
  messages: TRANSLATIONS,
})

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: function (to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
 }
});



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");